import React, { Component } from 'react';
import { Grid, Row, Col, Table, ButtonToolbar, Button } from 'react-bootstrap';

import { DayTypesCommand } from '../commands/DayTypesCommand';
import { DayTypeForm } from './DayTypeForm';
import { DayTypesOrderSetter } from './DayTypesOrderSetter';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { TitleRow } from '../../TitleRow';
import { TableButton } from '../../TableButton';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchBar } from '../../SearchBar';
import { SearchHelper } from '../../helpers/SearchHelper';

export class DayTypes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commands: {
                dayTypes: new DayTypesCommand(),
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50,
                filter: ""
            },
            form: {
                title: undefined,
                data: undefined,
                original: undefined
            },
            orderSetter: {
                data: undefined
            },
            actions: {
                isLoading: true,
                isUpdating: false,
                isDeleting: false
            },
            render: {
                sort: {
                    property: "name",
                    type: "ascending"
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.getDayTypes();
    }

    // ----------------------

    getDayTypes(resetData = false) {
        if (resetData) {
            const { table } = this.state;

            table.data = [];

            this.setState({
                table: table
            });
        }

        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;
        
        actions.isLoading = true;
        commands.dayTypes.getAll(
            selectedProviderId,
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    // ---------------------------

    setErrorMessage(messageReceived) {
        const { message } = this.state;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    setSuccessMessage(messageReceived) {
        const { message } = this.state;
        const updatedMessage = Object.assign({}, message);

        if (message.show) {
            updatedMessage.message = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: updatedMessage
        });
    }

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    listErrorCallback(messageReceived) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.data = [];
        table.page = 1;
        this.setErrorMessage(messageReceived);

        this.setState({
            table: table,
            actions: actions
        });
    }

    operationSuccessCallback(messageReceived, updateAction) {
        const { actions } = this.state;

        actions[updateAction] = false;
        this.setSuccessMessage(messageReceived);

        this.setState({
            actions: actions
        });

        this.getDayTypes();
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions } = this.state;

        actions[updateAction] = false;
        this.setErrorMessage(messageReceived);

        this.setState({
            actions: actions
        });
    }

    // ---------------------------

    onCreateClick() {
        const { form } = this.state;

        form.original = null;
        form.data = {
            id: 0,
            type: 1,
            name: ""
        };
        form.title = "Criar";

        this.setState({
            form: form
        });
    }

    onSetOrderClick() {
        const { table, orderSetter } = this.state;

        orderSetter.data = table.data.map(item => Object.assign({}, item)).sort((a, b) => a.order - b.order);

        this.setState({
            orderSetter: orderSetter
        });
    }

    onEditClick(data) {
        const { form } = this.state;

        form.original = data;
        form.data = Object.assign({}, data);
        form.title = "Editar";

        this.setState({
            form: form
        });
    }

    onDeleteClick(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o Tipo de Dia "${data.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: data.id
                }
            }
        });
    }

    onDayTypeSave(data) {
        const { commands, actions } = this.state;
        commands.dayTypes.save(
            data,
            (a) => this.operationSuccessCallback(a, "isUpdating"),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        actions.isUpdating = true;
        this.setState({
            actions: actions
        });

        this.onDayTypeFormExit();
    }

    onDayTypeFormExit() {
        this.setState({
            form: {
                title: undefined,
                data: undefined,
                original: undefined,
            }
        });
    }

    onOrderSetterSave(data) {
        const { commands, actions } = this.state;

        commands.dayTypes.setOrder(
            data,
            (a) => this.operationSuccessCallback(a, "isUpdating"),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        actions.isUpdating = true;
        this.setState({
            actions: actions
        });

        this.onOrderSetterExit();
    }

    onOrderSetterExit() {
        this.setState({
            orderSetter: {
                data: undefined
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;
            commands.dayTypes.delete(
                argument.id,
                (a) => this.operationSuccessCallback(a, "isDeleting"),
                (a) => this.operationErrorCallback(a, "isDeleting")
            );

            actions.isDeleting = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ---------------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    onChangePage(page) {
        const { table } = this.state;

        table.page = page;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elements) {
        const { table } = this.state;

        table.elementsPerPage = elements;

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    // -------------------

    sortData(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(undefined === aValue) {
            aValue = "";
        }

        if(undefined === bValue) {
            bValue = "";
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // -------------------

    renderOrderSetter() {
        const { orderSetter } = this.state;

        if (null === orderSetter.data || undefined === orderSetter.data) {
            return null;
        }

        return (
            <DayTypesOrderSetter data={orderSetter.data}
                onSave={(a) => this.onOrderSetterSave(a)}
                onHide={() => this.onOrderSetterExit()} />
        );
    }

    renderForm() {
        const { form } = this.state;

        if (null === form.data || undefined === form.data) {
            return null;
        }

        return (
            <DayTypeForm title={form.title}
                data={form.data}
                onSave={(a) => this.onDayTypeSave(a)}
                onHide={() => this.onDayTypeFormExit()} />
        );
    }

    renderButtons(data) {
        if (0 === data.type) {
            return null;
        }

        return (
            <ButtonToolbar className="pull-right">
                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.onEditClick(data)} />
                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteClick(data)} />
            </ButtonToolbar>
        );
    }

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderTable(isWaiting) {
        const { table, render } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["name"]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.sort((a, b) => this.sortData(render.sort, a, b))
            .slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <div className="table-loading">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th className="sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody className={isWaiting ? "overlay" : ""}>
                                    {
                                        partialData.map((data, idx) =>
                                            <tr key={`day-type-${idx}`}>
                                                <td>{data.name}</td>
                                                <td>{this.renderButtons(data)}</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>

                            <PaginationBuilder
                                currentPage={activePage}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={dataFiltered.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                            {this.renderLoading(isWaiting)}
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { actions, message, dialog } = this.state;

        return (
            <div>
                <TitleRow title="Tipos de Dia" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.onCreateClick()}>CRIAR</Button>
                            <Button onClick={() => this.onSetOrderClick()}>DEFINIR PRIORIDADE</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable(actions.isLoading || actions.isUpdating || actions.isDeleting)}
                {this.renderForm()}
                {this.renderOrderSetter()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
